import { render, staticRenderFns } from "./xskAddpick.vue?vue&type=template&id=5dcbb4cd&scoped=true&"
import script from "./xskAddpick.vue?vue&type=script&lang=js&"
export * from "./xskAddpick.vue?vue&type=script&lang=js&"
import style0 from "./xskAddpick.vue?vue&type=style&index=0&lang=css&"
import style1 from "./xskAddpick.vue?vue&type=style&index=1&id=5dcbb4cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbb4cd",
  null
  
)

export default component.exports